import {
  CLEAR_EDIT_MARIGRAM,
  GET_EDIT_MARIGRAM_REQUEST,
  CREATE_EDIT_MARIGRAM_REQUEST,
  UPDATE_EDIT_MARIGRAM_REQUEST,
  EDIT_MARIGRAM_TSUNAMI_REQUEST,
  EDIT_MARIGRAM_TSUNAMI_SEARCH_REQUEST,
  EDIT_MARIGRAM_REFERENCE_REQUEST,
  EDIT_MARIGRAM_REFERENCE_SEARCH_REQUEST,
  EDIT_MARIGRAM_COUNTRY_REQUEST,
  EDIT_MARIGRAM_LOCATION_REQUEST,
  EDIT_MARIGRAM_STATE_REQUEST,
  EDIT_MARIGRAM_TSUNAMI_SORT,
  EDIT_MARIGRAM_REFERENCE_SORT,
  EDIT_MARIGRAM_OPEN_CONFIRMATION,
  EDIT_MARIGRAM_CANCEL_CONFIRMATION,
  EDIT_MARIGRAM_REFERENCE_TOGGLE_COLUMN,
  EDIT_MARIGRAM_TSUNAMI_TOGGLE_COLUMN,
} from './marigramEditReducer';

export const getMarigram = ({ id, history }) => ({ type: GET_EDIT_MARIGRAM_REQUEST, id, history });
export const clearMarigram = () => ({ type: CLEAR_EDIT_MARIGRAM });
export const createMarigram = ({
  data, formModel, location, goBack, history,
}) => ({
  type: CREATE_EDIT_MARIGRAM_REQUEST, data, formModel, location, goBack, history,
});
export const updateMarigram = ({
  data, id, formModel, location, goBack, history,
}) => ({
  type: UPDATE_EDIT_MARIGRAM_REQUEST, data, id, formModel, location, goBack, history,
});
export const searchTsunamis = ({ queryParameters, history }) => ({
  type: EDIT_MARIGRAM_TSUNAMI_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getTsunami = ({ id, history }) => ({ type: EDIT_MARIGRAM_TSUNAMI_REQUEST, id, history });
export const searchReferences = ({ queryParameters, history }) => ({
  type: EDIT_MARIGRAM_REFERENCE_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getReferences = ({ id, history }) => ({ type: EDIT_MARIGRAM_REFERENCE_REQUEST, id, history });

export const getCountries = ({ history }) => ({ type: EDIT_MARIGRAM_COUNTRY_REQUEST, history });
export const getLocations = ({ history }) => ({ type: EDIT_MARIGRAM_LOCATION_REQUEST, history });
export const getStates = ({ history }) => ({ type: EDIT_MARIGRAM_STATE_REQUEST, history });
export const sortTsunamis = sort => ({ type: EDIT_MARIGRAM_TSUNAMI_SORT, sort });
export const sortReferences = sort => ({ type: EDIT_MARIGRAM_REFERENCE_SORT, sort });

export const openEditConfirmation = ({ formData }) => ({ type: EDIT_MARIGRAM_OPEN_CONFIRMATION, formData });
export const cancelEditConfirmation = () => ({ type: EDIT_MARIGRAM_CANCEL_CONFIRMATION });

export const toggleTsunamiColumns = visibleColumns => ({ type: EDIT_MARIGRAM_TSUNAMI_TOGGLE_COLUMN, visibleColumns });
export const toggleReferenceColumns = visibleColumns => ({ type: EDIT_MARIGRAM_REFERENCE_TOGGLE_COLUMN, visibleColumns });
